import { render, staticRenderFns } from "./ApplyTaxLossModal.vue?vue&type=template&id=33b09d78"
import script from "./ApplyTaxLossModal.vue?vue&type=script&lang=js"
export * from "./ApplyTaxLossModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ovilla/Documents/strappberry/catara-server/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33b09d78')) {
      api.createRecord('33b09d78', component.options)
    } else {
      api.reload('33b09d78', component.options)
    }
    module.hot.accept("./ApplyTaxLossModal.vue?vue&type=template&id=33b09d78", function () {
      api.rerender('33b09d78', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/base/modal/ApplyTaxLossModal.vue"
export default component.exports